
import config from '@/config'
import { operateCreditlist } from '@/api/user.js'
import { award, isAward } from '@/api/lottery'
import addressPicker from '@/views/components/address-picker2'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XButton from 'vux/src/components/x-button/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Icon from 'vux/src/components/icon/index.vue'

import { getAddressDefault, addAddress, editAddress } from '@/api/user'
import {
addCreditParty,
relation,
view,
addPartyCount,
cutCreditPartyNum
} from '@/api/jfhl.js'
import { updateuser, add } from '@/api/lottery.js'
export default {
directives: {
TransferDom
},
components: {
XDialog,
XButton,
Group,
XInput,
addressPicker
},
data () {
return {
lotid: 0,
showOpen: false,
prize: '',
partyid: this.$route.params.partyid,
partyuserid: '',
startTime: '',
endTime: '',
owner_type: config.owner_type,
isAward: 1, // 是否中奖
showAddress: false,
personObj: {
NAME: '',
ADDRESS: '',
MOBILE: '',
CITYID: '',
COUNTYID: '',
PROVINCEID: ''
},
addressValue: [],
addressid: '',
isAddressButton: true,
defautAddress: true,
num: 1
}
},
created () {
this.addcount() 
this.addIntegral() 
this.getview() 
this.getAddress()
},
computed: {
accountid () {
return this.$store.state.user.accountid
},
userid () {
return this.$store.state.user.userid
}
},
watch: {
addressValue: {
handler: function (val) {
this.personObj.PROVINCEID = val[0]
this.personObj.CITYID = val[1]
this.personObj.COUNTYID = val[2]
},
deep: true
}
},
methods: {
getPartyuserid (ADDRESS, cityid, countyid, provinceid) {
add({
userid: this.accountid,
partyid: this.partyid,
linkman: this.personObj.NAME,
phone: this.personObj.MOBILE,
address: ADDRESS,
provinceid: provinceid,
cityid: cityid,
countyid: countyid
}).then(res => {
this.partyuserid = res.obj.partyuserid
})
},

isAddress () {
updateuser({
lotid: this.lotid,
openid: this.userid
}).then(res => {
if (res.obj.isaddress === 2) {
this.isAddressButton = true
} else {
this.isAddressButton = false
}
})
},

getAddress () {
getAddressDefault({
accountid: this.accountid,
userid: this.userid
}).then(res => {
if (res.returnValue !== '') {
this.defautAddress = true
this.personObj = res.returnValue
this.addressid = res.returnValue.ID

this.$set(
this.addressValue,
0,
res.returnValue.PROVINCEID.toString()
)
this.$set(this.addressValue, 1, res.returnValue.CITYID.toString())
this.$set(this.addressValue, 2, res.returnValue.COUNTYID.toString())
this.personObj.ADDRESS = res.returnValue.ADDRESS
this.getPartyuserid(
this.personObj.ADDRESS,
this.personObj.CITYID,
this.personObj.COUNTYID,
this.personObj.PROVINCEID
)
} else {
this.defautAddress = false
}
})
},

sumbit () {
if (this.personObj.NAME === '') {
this.$vux.toast.text('请填写姓名！')
return false
}
if (this.personObj.ADDRESS === '') {
this.$vux.toast.text('请填写收货地址！')
return false
}
if (this.personObj.MOBILE === '') {
this.$vux.toast.text('请填写手机号码！')
return false
}
if (!/^\d{11}$/.test(this.personObj.MOBILE)) {
this.$vux.toast.text('手机号码格式不对哦～', 'middle')
return false
}
if (!this.defautAddress) {
addAddress({
accountid: this.accountid,
openid: this.openid,
name: this.personObj.NAME,
mobile: this.personObj.MOBILE,
address: this.personObj.ADDRESS,
provinceid: this.personObj.PROVINCEID,
cityid: this.personObj.CITYID,
countyid: this.personObj.COUNTYID,
isdefault: 1
}).then(data => {
if (data.status == 'suc') {
this.getPartyuserid(
this.personObj.ADDRESS,
this.personObj.CITYID,
this.personObj.COUNTYID,
this.personObj.PROVINCEID
)
this.showAddress = false
this.$vux.toast.text('提交成功!')
}
})
} else {
editAddress({
addressid: this.addressid,
accountid: this.accountid,
openid: this.userid,
name: this.personObj.NAME,
mobile: this.personObj.MOBILE,
address: this.personObj.ADDRESS,
provinceid: this.personObj.PROVINCEID,
cityid: this.personObj.CITYID,
countyid: this.personObj.COUNTYID,
isdefault: 1
}).then(data => {
if (data.status == 'suc') {
this.getPartyuserid(
this.personObj.ADDRESS,
this.personObj.CITYID,
this.personObj.COUNTYID,
this.personObj.PROVINCEID
)
this.showAddress = false
this.$vux.toast.text('提交成功!')
}
})
}
},

isawardNow () {
isAward({
lotid: this.lotid,
openid: this.userid
}).then(data => {
if (data.obj.isaward === 1 && data.obj.iszhongjiang === 1) {
this.isAward = 2
this.num = 0
this.$vux.toast.text('今天您已经抽过奖')
} else {
}
})
},

addcount () {
addPartyCount({
partyid: this.partyid,
accoutid: this.accountid,
credittype: 1
}).then(res => {})
},

addIntegral (credit) {
operateCreditlist({
accountid: this.accountid,
rulecode: 'party_rule',
credit: 1,
owner_type: this.owner_type,
relationtype: 2,
relationid: 1,
terminaltype: 2
}).then(res => {})
},

addJiFen (credit) {
addCreditParty({
accoutid: this.accountid,
credit: credit,
partyid: this.partyid,
type: 1
}).then(res => {})
},

getActiveNum () {
cutCreditPartyNum({
accoutid: this.accountid
}).then(res => {
if (this.num - parseInt(res.obj.num) <= 0) {
this.$vux.alert.show({
content: '您的抽奖次数已经用完'
})
}
})
},

getview () {
view({
id: this.partyid
}).then(res => {
this.lotid = res.obj.lotid
this.paperInfoid = res.obj.paperid
this.startTime = res.obj.signstartdate.replace(/-/g, '/')
this.endTime = res.obj.signenddate.replace(/-/g, '/')
this.isCurrentTime(this.startTime, this.endTime)

this.isAddress()
})
},

isCurrentTime (beginTime, endTime) {
var currentTime = new Date()
var beginTime = new Date(beginTime)
var endTime = new Date(endTime)
if (currentTime < beginTime) {
this.$vux.alert.show({
content: '抽奖活动还未开始'
})
return false
}
if (currentTime >= endTime) {
this.$vux.alert.show({
content: '抽奖活动已结束'
})
return false
}
this.isawardNow() 
},

isaward () {
award({
lotid: this.lotid,
openid: this.userid,
lotteryNum: 1
}).then(data => {
if (data.success) {
this.isAward = data.obj.isaward
this.prize = data.obj.item
this.num = 0
if (data.obj.isaward === 2) {
this.$vux.toast.text('今天您已经抽过奖')
return false
}
if (data.obj.item.indexOf('积分') != -1) {
this.addJiFen(data.obj.item.replace(/[^0-9]/gi, ''))
} else {

relation({
partyuserid: this.partyuserid,
lotid: this.lotid,
userid: this.accountid,
openid: this.userid
}).then(data => {})
}
this.showOpen = true
}
})
},

winning () {
setTimeout(() => {
this.showOpen = true
}, 2000)
},

viewResult () {
this.$router.push({
name: 'choujiang2Result',
params: { lotid: this.lotid }
})
},
clickAddress () {
this.showOpen = false
this.showAddress = true
}
}
}
